import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../shared/Typography';

import androidAppStore from '../../assets/images/android-app-store.png';

const AndroidButton = () => {
  const { t } = useTranslation('buttonAndroid');
  return (
    <Text link href={t('link_to_google_play_store')}>
      <img src={androidAppStore} alt={t('alt')} width='135' />
    </Text>
  );
};

export default AndroidButton;



// WEBPACK FOOTER //
// ./src/components/shared/ButtonAndroid.js